



































































































































import IRPTQueriesParameters from '@/store/models/IRPTQueriesParameters';
import IRPTQueries from '@/store/models/IRPTQueries';
import IRPTParameters from '@/store/models/IRPTParameters';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import TableRowAction from '../shared/TableRowAction.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class RPTQueriesParametersSelector extends Vue {
    searchRPTQueriesParameters: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'Parameter', value: 'parameterName' },
        { text: 'Query', value: 'queryName' },
        { text: 'Actions', value: '' }
    ];
    editedIndex : number = -1;
    editedItem : IRPTQueriesParameters = {
        id: "",
        idRPTParameters: "",
        parameterName: "",
        idRPTQueries: "",
        queryName: ""
    }
    defaultItem : IRPTQueriesParameters = {
        id: "",
        idRPTParameters: "",
        parameterName: "",
        idRPTQueries: "",
        queryName: ""
    }
    sortBy: string = 'parameterName';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    RPTQueriesParametersList !: IRPTQueriesParameters[];
    @Prop({ type: Array, required: true })
    RPTQueriesList !: IRPTQueries[];
    @Prop({ type: Array, required: true })
    RPTParametersList !: IRPTParameters[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedRPTQueriesParameters : IRPTQueriesParameters[] = [];
    selectedParameter : IRPTParameters = {} as IRPTParameters;
    selectedQuery : IRPTQueries = {} as IRPTQueries;

    get formTitle() { return this.editedIndex === -1 ? 'New Query Parameter' : 'Edit Query Parameter'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetRPTQueriesParameters() {
        this.selectedRPTQueriesParameters = [];
        this.selectedParameter = {} as IRPTParameters;
        this.selectedQuery = {} as IRPTQueries;
    }

    editRPTQueriesParameters (item: any, dbox = true) {
        this.editedIndex = this.RPTQueriesParametersList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveRPTQueriesParameters (listAdressType: IRPTQueriesParameters) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.editedItem.idRPTParameters = this.selectedParameter.id;
            this.editedItem.parameterName = this.selectedParameter.parameterName;
            this.editedItem.idRPTQueries = this.selectedQuery.id;
            this.editedItem.queryName = this.selectedQuery.queryName;
            if (this.editedIndex > -1 || this.selectedRPTQueriesParameters[0]) {
                this.close();
                this.$emit('editRPTQueriesParameters', this.editedItem);
                Object.assign(this.RPTQueriesParametersList[this.editedIndex], this.editedItem);
            } else {
                this.selectedRPTQueriesParameters[0] = this.editedItem;
                this.$emit('saveRPTQueriesParameters', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteRPTQueriesParameters (rptQueryParameters: IRPTQueriesParameters) {
        this.$emit('deleteRPTQueriesParameters', rptQueryParameters);
        this.close();
        this.resetRPTQueriesParameters();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectRPTQueriesParameters(item : any) : void {
        if (!this.selectedRPTQueriesParameters.includes(item)) {
            this.selectedRPTQueriesParameters = [];
            this.selectedRPTQueriesParameters = [item];
            this.selectedParameter = this.RPTParametersList.find(p => p.id === item.id_RPT_Parameters) as IRPTParameters;
            this.selectedQuery = this.RPTQueriesList.find(p => p.id === item.id_RPT_Queries) as IRPTQueries;
        } else {
            this.selectedRPTQueriesParameters = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
